__turbopack_context__.v({
  "content": "TermsAndConditions-module__YsCcSG__content",
});
